export const actions = {
  FIREWALLIP_LOAD_REQUESTED: 'FIREWALLIP_LOAD_REQUESTED',
  FIREWALLIP_LOAD_SUCCEEDED: 'FIREWALLIP_LOAD_SUCCEEDED',
  FIREWALLIP_LOAD_FAILED: 'FIREWALLIP_LOAD_FAILED',
}

export const getFirewallipAll = dispatch => {
  dispatch({
    type: actions.FIREWALLIP_LOAD_REQUESTED,
  })
}
